const rankings = [
  { rank: 1, title: '鬼灭之刃', type: '热血冒险', score: '9.8', change: 'up' },
  { rank: 2, title: '海贼王', type: '冒险热血', score: '9.7', change: 'same' },
  { rank: 3, title: '咒术回战', type: '黑暗奇幻', score: '9.6', change: 'up' },
  { rank: 4, title: '间谍过家家', type: '家庭喜剧', score: '9.5', change: 'up' },
  { rank: 5, title: '葬送的芙莉莲', type: '治愈奇幻', score: '9.5', change: 'down' },
  { rank: 6, title: '电锯人', type: '黑暗热血', score: '9.3', change: 'up' },
  { rank: 7, title: '怪兽8号', type: '科幻战斗', score: '9.2', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            热度榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            全网读者评分最高的人气漫画TOP7
          </p>
          <div className="mt-8 bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
            {rankings.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 px-5 py-4 border-b border-background-200/50 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center shrink-0">
                  {item.rank <= 3 ? (
                    <span className={`font-heading text-base ${
                      item.rank === 1 ? 'text-primary-500' :
                      item.rank === 2 ? 'text-accent-500' :
                      'text-secondary-500'
                    }`}>
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-sm text-foreground-400">{item.rank}</span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-sm font-medium text-foreground-800">{item.title}</span>
                  <span className="ml-2 text-xs text-foreground-400">{item.type}</span>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <span className="text-sm font-medium text-foreground-700">{item.score}</span>
                  {item.change === 'up' && <i className="ri-arrow-up-fill text-primary-500 text-xs"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-fill text-secondary-500 text-xs"></i>}
                  {item.change === 'same' && <span className="text-xs text-foreground-300">—</span>}
                  {item.change === 'new' && <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700">新</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}